import styled from 'styled-components'

export const ScreenContainer = styled.div`
  width: 100%;
  padding: 0;
`

export const HeaderWrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  overflow: hidden;
`

export const HeaderButtons = styled.div`
  flex-shrink: 0;
  text-align: right;
  display: flex;
  gap: 16px;
`

export const HeaderTitleWrapper = styled.div`
  flex: 1;
  min-width: 0;
  padding-left: 10px;
  padding-bottom: 30px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`
